// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { AppConfigGetData, AppConfigGetResponses, AppConfigGetErrors, BasketDeleteActiveBasketData, BasketDeleteActiveBasketResponses, BasketDeleteActiveBasketErrors, BasketGetActiveBasketData, BasketGetActiveBasketResponses, BasketGetActiveBasketErrors, BasketDeleteBasketData, BasketDeleteBasketResponses, BasketDeleteBasketErrors, BasketGetBasketData, BasketGetBasketResponses, BasketGetBasketErrors, BasketAddMessagingProductData, BasketAddMessagingProductResponses, BasketAddMessagingProductErrors, BasketSelectParticipantData, BasketSelectParticipantResponses, BasketSelectParticipantErrors, BasketDeselectParticipantData, BasketDeselectParticipantResponses, BasketDeselectParticipantErrors, BasketDeleteFilesData, BasketDeleteFilesResponses, BasketDeleteFilesErrors, BasketAddFilesData, BasketAddFilesResponses, BasketAddFilesErrors, BasketGetExternalDataData, BasketGetExternalDataResponses, BasketGetExternalDataErrors, BasketSetExternalDataData, BasketSetExternalDataResponses, BasketSetExternalDataErrors, BasketSetReasonData, BasketSetReasonResponses, BasketSetReasonErrors, BasketRemoveItemsData, BasketRemoveItemsResponses, BasketRemoveItemsErrors, BasketGetFormAnswersData, BasketGetFormAnswersResponses, BasketGetFormAnswersErrors, BasketSetFormAnswersData, BasketSetFormAnswersResponses, BasketSetFormAnswersErrors, BasketPreCommitData, BasketPreCommitResponses, BasketPreCommitErrors, BasketDeleteCommitData, BasketDeleteCommitResponses, BasketDeleteCommitErrors, BasketCommitStatusQueryCommitStatusActionData, BasketCommitStatusQueryCommitStatusActionResponses, BasketCommitStatusQueryCommitStatusActionErrors, BasketContinueCommitData, BasketContinueCommitResponses, BasketContinueCommitErrors, BasketCreateCommitData, BasketCreateCommitResponses, BasketCreateCommitErrors, BasketCreateCommitOldData, BasketCreateCommitOldResponses, BasketCreateCommitOldErrors, CareCompanionCreateSessionData, CareCompanionCreateSessionResponses, CareCompanionCreateSessionErrors, CareCompanionEndSessionData, CareCompanionEndSessionResponses, CareCompanionEndSessionErrors, PrivacyPolicyWebInfoData, PrivacyPolicyWebInfoResponses, PrivacyPolicyWebInfoErrors, ClientAppPointToPrivacyPolicyData, ClientAppPointToPrivacyPolicyResponses, ClientAppPointToTermsOfServiceData, ClientAppPointToTermsOfServiceResponses, ClientAppGetConfigData, ClientAppGetConfigResponses, ClientAppGetConfigErrors, ClientAppointmentsGetUpcomingAndUnfinishedData, ClientAppointmentsGetUpcomingAndUnfinishedResponses, ClientAppointmentsGetUpcomingAndUnfinishedErrors, ClientAppointmentsCancelData, ClientAppointmentsCancelResponses, ClientAppointmentsCancelErrors, ClientAppointmentsGetData, ClientAppointmentsGetResponses, ClientAppointmentsGetErrors, ClientAppointmentsGetCallStatusData, ClientAppointmentsGetCallStatusResponses, ClientAppointmentsGetCallStatusErrors, ClientAppointmentsDeclineData, ClientAppointmentsDeclineResponses, ClientAppointmentsDeclineErrors, ClientAppointmentsUpdateLegalGuardiansData, ClientAppointmentsUpdateLegalGuardiansResponses, ClientAppointmentsUpdateLegalGuardiansErrors, ClientAppointmentsAddFileData, ClientAppointmentsAddFileResponses, ClientAppointmentsAddFileErrors, ClientAuthMethodsGetAuthMethodsData, ClientAuthMethodsGetAuthMethodsResponses, ClientAuthMethodsGetAuthMethodsErrors, ClientBookableTimeLocksCreateLockData, ClientBookableTimeLocksCreateLockResponses, ClientBookableTimeLocksCreateLockErrors, ClientBookableTimeLocksReleaseLockData, ClientBookableTimeLocksReleaseLockResponses, ClientBookableTimeLocksReleaseLockErrors, ClientBookableTimeLocksExtendLockData, ClientBookableTimeLocksExtendLockResponses, ClientBookableTimeLocksExtendLockErrors, ClientCasesListUpdatesData, ClientCasesListUpdatesResponses, ClientCasesListUpdatesErrors, ClientCasesMarkNewAppointmentSeenData, ClientCasesMarkNewAppointmentSeenResponses, ClientCasesMarkNewAppointmentSeenErrors, ClientCasesPrioritizedV2Data, ClientCasesPrioritizedV2Responses, ClientCasesPrioritizedV2Errors, ClientConditionsListData, ClientConditionsListResponses, ClientConditionsListErrors, ClientDropInEnqueueData, ClientDropInEnqueueResponses, ClientDropInEnqueueErrors, ClientDropInCancelData, ClientDropInCancelResponses, ClientDropInCancelErrors, ClientDropInGetTicketData, ClientDropInGetTicketResponses, ClientDropInGetTicketErrors, GetActiveTicketData, GetActiveTicketResponses, GetActiveTicketErrors, GetActiveTicketForRoomData, GetActiveTicketForRoomResponses, GetActiveTicketForRoomErrors, ClientDropInUploadData, ClientDropInUploadResponses, ClientDropInUploadErrors, ClientDropInListData, ClientDropInListResponses, ClientDropInListErrors, ClientDropInGetData, ClientDropInGetResponses, ClientDropInGetErrors, ClientDropInGetByUrlAliasData, ClientDropInGetByUrlAliasResponses, ClientDropInGetByUrlAliasErrors, ClientFormsListData, ClientFormsListResponses, ClientFormsListErrors, ClientFormsGetFormGraphData, ClientFormsGetFormGraphResponses, ClientFormsGetFormGraphErrors, ClientFormsGetRespondantData, ClientFormsGetRespondantResponses, ClientFormsGetRespondantErrors, ClientFormsSaveAnswersData, ClientFormsSaveAnswersResponses, ClientFormsSaveAnswersErrors, ClientFormsSetRespondantCompleteData, ClientFormsSetRespondantCompleteResponses, ClientFormsSetRespondantCompleteErrors, ClientGuiComponentsListData, ClientGuiComponentsListResponses, ClientGuiComponentsListErrors, ClientIdentityDeleteData, ClientIdentityDeleteResponses, ClientIdentityDeleteErrors, ClientIdentityGetData, ClientIdentityGetResponses, ClientIdentityGetErrors, ClientIdentityUpdateData, ClientIdentityUpdateResponses, ClientIdentityUpdateErrors, ClientIdentityInviteablePersonsData, ClientIdentityInviteablePersonsResponses, ClientIdentityInviteablePersonsErrors, ClientIdentityCanDeleteData, ClientIdentityCanDeleteResponses, ClientIdentityCanDeleteErrors, ClientIdentitySignOutData, ClientIdentitySignOutResponses, ClientIdentitySignOutErrors, ClientIdentityIsAliveData, ClientIdentityIsAliveResponses, ClientIdentityIsAliveErrors, ClientIdentityIsAliveOutsiderData, ClientIdentityIsAliveOutsiderResponses, ClientIdentityIsAliveOutsiderErrors, ClientMessagingListData, ClientMessagingListResponses, ClientMessagingListErrors, ClientMessagingGetData, ClientMessagingGetResponses, ClientMessagingGetErrors, ClientMessagingGetCaseData, ClientMessagingGetCaseResponses, ClientMessagingGetCaseErrors, ClientMessagingUpdateLegalGuardiansData, ClientMessagingUpdateLegalGuardiansResponses, ClientMessagingUpdateLegalGuardiansErrors, ClientMessagingCompletionCompleteCaseData, ClientMessagingCompletionCompleteCaseResponses, ClientMessagingCompletionCompleteCaseErrors, ClientNotificationTargetsDeleteStandardTargetData, ClientNotificationTargetsDeleteStandardTargetResponses, ClientNotificationTargetsDeleteStandardTargetErrors, ClientNotificationTargetsSetStandardTargetData, ClientNotificationTargetsSetStandardTargetResponses, ClientNotificationTargetsSetStandardTargetErrors, ClientNotificationTargetsDeleteVoipTargetData, ClientNotificationTargetsDeleteVoipTargetResponses, ClientNotificationTargetsDeleteVoipTargetErrors, ClientNotificationTargetsSetVoipTargetData, ClientNotificationTargetsSetVoipTargetResponses, ClientNotificationTargetsSetVoipTargetErrors, ClientPaymentsPaymentServicesData, ClientPaymentsPaymentServicesResponses, ClientPaymentsPaymentServicesErrors, ClientReceptionConditionsListData, ClientReceptionConditionsListResponses, ClientReceptionConditionsListErrors, ClientRegistrationGetRegistrationData, ClientRegistrationGetRegistrationResponses, ClientRegistrationGetRegistrationErrors, ClientRegistrationCompleteRegistrationData, ClientRegistrationCompleteRegistrationResponses, ClientRegistrationCompleteRegistrationErrors, ClientSmsStartAuthData, ClientSmsStartAuthResponses, ClientSmsStartAuthErrors, ClientSmsStartAuthWithCallTicketData, ClientSmsStartAuthWithCallTicketResponses, ClientSmsStartAuthWithCallTicketErrors, ClientSmsReSendCodeData, ClientSmsReSendCodeResponses, ClientSmsReSendCodeErrors, ClientSmsConfirmCodeData, ClientSmsConfirmCodeResponses, ClientSmsConfirmCodeErrors, ClientSmsPreRegisteredNumberData, ClientSmsPreRegisteredNumberResponses, ClientSmsPreRegisteredNumberErrors, ClientSurveysGetSurveyData, ClientSurveysGetSurveyResponses, ClientSurveysGetSurveyErrors, ClientSurveysAnswerSurveyData, ClientSurveysAnswerSurveyResponses, ClientSurveysAnswerSurveyErrors, ClientThemeGetPublicThemeData, ClientThemeGetPublicThemeResponses, ClientThemeGetPublicThemeErrors, ClientTimeslotsTimeslotsData, ClientTimeslotsTimeslotsResponses, ClientTimeslotsTimeslotsErrors, ClientTimeslotsTimeslotData, ClientTimeslotsTimeslotResponses, ClientTimeslotsTimeslotErrors, ClientTimeslotsSearchLocalityAvailabilityData, ClientTimeslotsSearchLocalityAvailabilityResponses, ClientTimeslotsSearchLocalityAvailabilityErrors, ClientTimeslotsGetAvailabilityCountsData, ClientTimeslotsGetAvailabilityCountsResponses, ClientTimeslotsGetAvailabilityCountsErrors, ClientTimeslotsGetSearchCapabilitiesData, ClientTimeslotsGetSearchCapabilitiesResponses, ClientTimeslotsGetSearchCapabilitiesErrors, ClientTimeslotsBookSlotData, ClientTimeslotsBookSlotResponses, ClientTimeslotsBookSlotErrors, ClientTimeslotsGetRescheduleTimeslotsData, ClientTimeslotsGetRescheduleTimeslotsResponses, ClientTimeslotsGetRescheduleTimeslotsErrors, ClientTimeslotsRebookWithNewTimeslotData, ClientTimeslotsRebookWithNewTimeslotResponses, ClientTimeslotsRebookWithNewTimeslotErrors, ClientTimeslotsGetRescheduleAvailabilityCountsData, ClientTimeslotsGetRescheduleAvailabilityCountsResponses, ClientTimeslotsGetRescheduleAvailabilityCountsErrors, ClientUnitsListUnitsData, ClientUnitsListUnitsResponses, ClientUnitsListUnitsErrors, ClientUnitsGetData, ClientUnitsGetResponses, ClientUnitsGetErrors, ClientUnitsGetThemeData, ClientUnitsGetThemeResponses, ClientUnitsGetThemeErrors, ClientUnitsGetAboutData, ClientUnitsGetAboutResponses, ClientUnitsGetAboutErrors, ClientUnitsGetTextsData, ClientUnitsGetTextsResponses, ClientUnitsGetTextsErrors, ClientUnitsGetIdentifierConflictsData, ClientUnitsGetIdentifierConflictsResponses, ClientUnitsGetIdentifierConflictsErrors, ClientUsageAgreementsGetDocumentsData, ClientUsageAgreementsGetDocumentsResponses, ClientUsageAgreementsGetDocumentsErrors, ClientUsageAgreementsAgreeToDocumentData, ClientUsageAgreementsAgreeToDocumentResponses, ClientUsageAgreementsAgreeToDocumentErrors, CurrencyGetData, CurrencyGetResponses, CurrencyGetErrors, DemandManagementIsMessagingOpenData, DemandManagementIsMessagingOpenResponses, DemandManagementIsTriageOpenData, DemandManagementIsTriageOpenResponses, DemandManagementGetRuleSetData, DemandManagementGetRuleSetResponses, DemandManagementGetRuleSetErrors, ExternalDataUploadExternalDataData, ExternalDataUploadExternalDataResponses, ExternalDataUploadExternalDataErrors, HomeGuiComponentsListDeprecatedData, HomeGuiComponentsListDeprecatedResponses, HomeGuiComponentsListDeprecatedErrors, HomeGuiComponentsListData, HomeGuiComponentsListResponses, HomeGuiComponentsListErrors, IdentityIdpSignOutIdpData, IdentityIdpSignOutIdpResponses, IdentityIdpSignOutIdp2Data, IdentityIdpSignOutIdp2Responses, IdpAuthMethodsGetAuthMethodsData, IdpAuthMethodsGetAuthMethodsResponses, IdpAuthMethodsGetAuthMethodsErrors, InformationGatheringGetEligibilityData, InformationGatheringGetEligibilityResponses, InformationGatheringGetEligibilityErrors, InformationGatheringStoreSubmissionData, InformationGatheringStoreSubmissionResponses, InformationGatheringStoreSubmissionErrors, LocaleGetData, LocaleGetResponses, LocaleGetErrors, NavigationStartData, NavigationStartResponses, NavigationStartErrors, NotificationSettingsGetComplianceSettingsData, NotificationSettingsGetComplianceSettingsResponses, NotificationSettingsGetComplianceSettingsErrors, NotificationSettingsUpdateComplianceSettingsData, NotificationSettingsUpdateComplianceSettingsResponses, NotificationSettingsUpdateComplianceSettingsErrors, PaymentsGetBillData, PaymentsGetBillResponses, PaymentsGetBillErrors, PhysicalLocationsGetPhysicalLocationData, PhysicalLocationsGetPhysicalLocationResponses, PhysicalLocationsGetPhysicalLocationErrors, PhysicalLocationsGetPhysicalLocationsData, PhysicalLocationsGetPhysicalLocationsResponses, PhysicalLocationsGetPhysicalLocationsErrors, RateGetMessagingPriceData, RateGetMessagingPriceResponses, RateGetMessagingPriceErrors, RecentReceptionsListRecentlyVisitedData, RecentReceptionsListRecentlyVisitedResponses, RecentReceptionsListRecentlyVisitedErrors, RecentReceptionsRegisterVisitData, RecentReceptionsRegisterVisitResponses, RecentReceptionsRegisterVisitErrors, RecentReceptionsDeleteVisitData, RecentReceptionsDeleteVisitResponses, RecentReceptionsDeleteVisitErrors, ReceptionListFromUnitIdData, ReceptionListFromUnitIdResponses, ReceptionListFromUnitIdErrors, ReceptionSearchData, ReceptionSearchResponses, ReceptionSearchErrors, RedRobinStartSessionData, RedRobinStartSessionResponses, RedRobinStartSessionErrors, RedRobinStartSessionV2Data, RedRobinStartSessionV2Responses, RedRobinStartSessionV2Errors, RedRobinGetPatientEntryUrlData, RedRobinGetPatientEntryUrlResponses, RedRobinGetPatientEntryUrlErrors, RedRobinGetAccessInfoData, RedRobinGetAccessInfoResponses, RedRobinGetAccessInfoErrors, SearchLimitationDeleteContextData, SearchLimitationDeleteContextResponses, SearchLimitationDeleteContextErrors, SearchLimitationGetSearchLimitationData, SearchLimitationGetSearchLimitationResponses, SearchLimitationGetSearchLimitationErrors, SearchLimitationCreateSearchLimitationData, SearchLimitationCreateSearchLimitationResponses, SessionInformationGetClientSessionInformationData, SessionInformationGetClientSessionInformationResponses, SessionInformationGetClientSessionInformationErrors, SessionInformationGetGuestSessionInformationData, SessionInformationGetGuestSessionInformationResponses, SessionInformationGetGuestSessionInformationErrors, TranslationSetsGetData, TranslationSetsGetResponses, TranslationSetsGetErrors, UnitsPhysicalLocationsGetPhysicalLocationsData, UnitsPhysicalLocationsGetPhysicalLocationsResponses, UnitsPhysicalLocationsGetPhysicalLocationsErrors, UserFilesGetFileIdentifierData, UserFilesGetFileIdentifierResponses, UserFilesGetFileIdentifierErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class AppConfigService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.AppConfigController
     */
    public static appConfigGet<ThrowOnError extends boolean = false>(options: Options<AppConfigGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<AppConfigGetResponses, AppConfigGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/AppConfig',
            ...options
        });
    }
}

export class BasketService {
    /**
     * Deletes the active basket for the given reception.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketDeleteActiveBasket<ThrowOnError extends boolean = false>(options: Options<BasketDeleteActiveBasketData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<BasketDeleteActiveBasketResponses, BasketDeleteActiveBasketErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/Active/{receptionId}',
            ...options
        });
    }
    
    /**
     * Gets or creates the active basket for the given reception.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketGetActiveBasket<ThrowOnError extends boolean = false>(options: Options<BasketGetActiveBasketData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<BasketGetActiveBasketResponses, BasketGetActiveBasketErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/Active/{receptionId}',
            ...options
        });
    }
    
    /**
     * Deletes a basket by id.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketDeleteBasket<ThrowOnError extends boolean = false>(options: Options<BasketDeleteBasketData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<BasketDeleteBasketResponses, BasketDeleteBasketErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}',
            ...options
        });
    }
    
    /**
     * Gets the contents of a basket.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketGetBasket<ThrowOnError extends boolean = false>(options: Options<BasketGetBasketData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<BasketGetBasketResponses, BasketGetBasketErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}',
            ...options
        });
    }
    
    /**
     * Adds a messaging conversation product to the basket.
     * If the client is currently representing another person, participants (the subject and their legal guardians)
     * are resolved automatically via the PU service and returned in the result. The acting client is excluded
     * from the guardian list. Participants are initially unselected.
     */
    public static basketAddMessagingProduct<ThrowOnError extends boolean = false>(options: Options<BasketAddMessagingProductData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<BasketAddMessagingProductResponses, BasketAddMessagingProductErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/MessagingConversation',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     * Marks a participant as selected for inclusion when the basket is committed.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketSelectParticipant<ThrowOnError extends boolean = false>(options: Options<BasketSelectParticipantData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<BasketSelectParticipantResponses, BasketSelectParticipantErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Products/{basketProductId}/Participants/{participantId}/select',
            ...options
        });
    }
    
    /**
     * Marks a participant as deselected so they are not included when the basket is committed.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketDeselectParticipant<ThrowOnError extends boolean = false>(options: Options<BasketDeselectParticipantData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<BasketDeselectParticipantResponses, BasketDeselectParticipantErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Products/{basketProductId}/Participants/{participantId}/deselect',
            ...options
        });
    }
    
    /**
     * Deletes file references from a basket product.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketDeleteFiles<ThrowOnError extends boolean = false>(options: Options<BasketDeleteFilesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<BasketDeleteFilesResponses, BasketDeleteFilesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Item/{basketItemId}/Files',
            ...options
        });
    }
    
    /**
     * Adds file references to a basket product.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketAddFiles<ThrowOnError extends boolean = false>(options: Options<BasketAddFilesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<BasketAddFilesResponses, BasketAddFilesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Item/{basketItemId}/Files',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets external data references for a basket product.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketGetExternalData<ThrowOnError extends boolean = false>(options: Options<BasketGetExternalDataData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<BasketGetExternalDataResponses, BasketGetExternalDataErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Item/{basketProductId}/ExternalData',
            ...options
        });
    }
    
    /**
     * Sets external data references on a basket product.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketSetExternalData<ThrowOnError extends boolean = false>(options: Options<BasketSetExternalDataData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<BasketSetExternalDataResponses, BasketSetExternalDataErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Item/{basketProductId}/ExternalData',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sets the reason for visit on a basket product.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketSetReason<ThrowOnError extends boolean = false>(options: Options<BasketSetReasonData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<BasketSetReasonResponses, BasketSetReasonErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Item/{basketItemId}/Reason',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     * Removes a product from the basket.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketRemoveItems<ThrowOnError extends boolean = false>(options: Options<BasketRemoveItemsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<BasketRemoveItemsResponses, BasketRemoveItemsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Items/{basketItemId}',
            ...options
        });
    }
    
    /**
     * Gets form answers for a basket product.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketGetFormAnswers<ThrowOnError extends boolean = false>(options: Options<BasketGetFormAnswersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<BasketGetFormAnswersResponses, BasketGetFormAnswersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/FormAnswers/{basketProductId}/{formId}',
            ...options
        });
    }
    
    /**
     * Submits or updates form answers for a basket product.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketSetFormAnswers<ThrowOnError extends boolean = false>(options: Options<BasketSetFormAnswersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<BasketSetFormAnswersResponses, BasketSetFormAnswersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/FormAnswers/{basketProductId}/{formId}',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     * Validates and prepares the basket for commit. Same as CreateCommit.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketPreCommit<ThrowOnError extends boolean = false>(options: Options<BasketPreCommitData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<BasketPreCommitResponses, BasketPreCommitErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/PreCommit',
            ...options
        });
    }
    
    /**
     * Cancels and fails an in-progress commit job.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketDeleteCommit<ThrowOnError extends boolean = false>(options: Options<BasketDeleteCommitData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<BasketDeleteCommitResponses, BasketDeleteCommitErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/Commit/{commitJobId}',
            ...options
        });
    }
    
    /**
     * Continues a previously started commit job.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketContinueCommit<ThrowOnError extends boolean = false>(options: Options<BasketContinueCommitData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<BasketContinueCommitResponses, BasketContinueCommitErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/Commit/{commitJobId}',
            ...options
        });
    }
    
    /**
     * Creates a commit job for the basket, validates, and attempts to finalize.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketCreateCommit<ThrowOnError extends boolean = false>(options: Options<BasketCreateCommitData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<BasketCreateCommitResponses, BasketCreateCommitErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/Commit',
            ...options
        });
    }
    
    /**
     * Creates a commit job for the basket. Legacy version returning only the job id.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
     */
    public static basketCreateCommitOld<ThrowOnError extends boolean = false>(options: Options<BasketCreateCommitOldData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<BasketCreateCommitOldResponses, BasketCreateCommitOldErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/{basketId}/CreateCommit',
            ...options
        });
    }
}

export class BasketCommitStatusService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketCommitStatusController
     */
    public static basketCommitStatusQueryCommitStatusAction<ThrowOnError extends boolean = false>(options: Options<BasketCommitStatusQueryCommitStatusActionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<BasketCommitStatusQueryCommitStatusActionResponses, BasketCommitStatusQueryCommitStatusActionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Baskets/Commit/{commitJobId}',
            ...options
        });
    }
}

export class CareCompanionService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.CareCompanionController
     */
    public static careCompanionCreateSession<ThrowOnError extends boolean = false>(options?: Options<CareCompanionCreateSessionData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<CareCompanionCreateSessionResponses, CareCompanionCreateSessionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/CareCompanion/Session',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.CareCompanionController
     */
    public static careCompanionEndSession<ThrowOnError extends boolean = false>(options: Options<CareCompanionEndSessionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<CareCompanionEndSessionResponses, CareCompanionEndSessionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/CareCompanion/Session/{sessionId}',
            ...options
        });
    }
}

export class ClientAppService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppController
     */
    public static privacyPolicyWebInfo<ThrowOnError extends boolean = false>(options: Options<PrivacyPolicyWebInfoData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<PrivacyPolicyWebInfoResponses, PrivacyPolicyWebInfoErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/App/{platform}/{appIdentifier}/WebInfo',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppController
     */
    public static clientAppPointToPrivacyPolicy<ThrowOnError extends boolean = false>(options: Options<ClientAppPointToPrivacyPolicyData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientAppPointToPrivacyPolicyResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/App/{platform}/{appIdentifier}/PrivacyPolicy',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppController
     */
    public static clientAppPointToTermsOfService<ThrowOnError extends boolean = false>(options: Options<ClientAppPointToTermsOfServiceData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientAppPointToTermsOfServiceResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/App/{platform}/{appIdentifier}/TermsOfService',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppController
     */
    public static clientAppGetConfig<ThrowOnError extends boolean = false>(options: Options<ClientAppGetConfigData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientAppGetConfigResponses, ClientAppGetConfigErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/App/{platform}/{appIdentifier}',
            ...options
        });
    }
}

export class ClientAppointmentsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
     */
    public static clientAppointmentsGetUpcomingAndUnfinished<ThrowOnError extends boolean = false>(options?: Options<ClientAppointmentsGetUpcomingAndUnfinishedData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientAppointmentsGetUpcomingAndUnfinishedResponses, ClientAppointmentsGetUpcomingAndUnfinishedErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Appointments',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
     */
    public static clientAppointmentsCancel<ThrowOnError extends boolean = false>(options: Options<ClientAppointmentsCancelData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<ClientAppointmentsCancelResponses, ClientAppointmentsCancelErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Appointments/{ticket}',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     * Used by booking participants (clients, outsiders or resources) to retrieve appointment details.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
     */
    public static clientAppointmentsGet<ThrowOnError extends boolean = false>(options: Options<ClientAppointmentsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientAppointmentsGetResponses, ClientAppointmentsGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Appointments/{ticket}',
            ...options
        });
    }
    
    /**
     * Used by booking participants (clients, outsiders or resources) to retrieve information about a call.
     * This endpoint is polled every X seconds while on the evaluation and lobby views to determine when a
     * toast notification should be shown, how many participants are in the call and whether the user
     * should be able to reconnect or not.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
     */
    public static clientAppointmentsGetCallStatus<ThrowOnError extends boolean = false>(options: Options<ClientAppointmentsGetCallStatusData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientAppointmentsGetCallStatusResponses, ClientAppointmentsGetCallStatusErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Appointments/{ticket}/CallStatus',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
     */
    public static clientAppointmentsDecline<ThrowOnError extends boolean = false>(options: Options<ClientAppointmentsDeclineData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<ClientAppointmentsDeclineResponses, ClientAppointmentsDeclineErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Appointments/Decline/{bookingId}',
            ...options
        });
    }
    
    /**
     * Used by clients to update the list of legal guardians invited to an existing booking.
     * The provided list represents the desired set of invited legal guardians; guardians that
     * are currently invited but are not in the list will be uninvited, and guardians in the list
     * that are not currently invited will be added as participants.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
     */
    public static clientAppointmentsUpdateLegalGuardians<ThrowOnError extends boolean = false>(options: Options<ClientAppointmentsUpdateLegalGuardiansData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<ClientAppointmentsUpdateLegalGuardiansResponses, ClientAppointmentsUpdateLegalGuardiansErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Appointments/{ticket}/LegalGuardians',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     * Used by booking participants (clients, outsiders or resources) to post files during a video call.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
     */
    public static clientAppointmentsAddFile<ThrowOnError extends boolean = false>(options: Options<ClientAppointmentsAddFileData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientAppointmentsAddFileResponses, ClientAppointmentsAddFileErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Appointments/{ticket}/files',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
}

export class ClientAuthMethodsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientAuthMethodsController
     */
    public static clientAuthMethodsGetAuthMethods<ThrowOnError extends boolean = false>(options: Options<ClientAuthMethodsGetAuthMethodsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientAuthMethodsGetAuthMethodsResponses, ClientAuthMethodsGetAuthMethodsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Auth/Methods',
            ...options
        });
    }
}

export class ClientBookableTimeLocksService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientBookableTimeLocksController
     */
    public static clientBookableTimeLocksCreateLock<ThrowOnError extends boolean = false>(options: Options<ClientBookableTimeLocksCreateLockData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientBookableTimeLocksCreateLockResponses, ClientBookableTimeLocksCreateLockErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/timeslots/{timeslotId}/locks',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientBookableTimeLocksController
     */
    public static clientBookableTimeLocksReleaseLock<ThrowOnError extends boolean = false>(options: Options<ClientBookableTimeLocksReleaseLockData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<ClientBookableTimeLocksReleaseLockResponses, ClientBookableTimeLocksReleaseLockErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/timeslotlocks/{bookableTimeLockId}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientBookableTimeLocksController
     */
    public static clientBookableTimeLocksExtendLock<ThrowOnError extends boolean = false>(options: Options<ClientBookableTimeLocksExtendLockData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<ClientBookableTimeLocksExtendLockResponses, ClientBookableTimeLocksExtendLockErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/timeslotlocks/{bookableTimeLockId}',
            ...options
        });
    }
}

export class ClientCasesService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Cases.ClientCasesController
     */
    public static clientCasesListUpdates<ThrowOnError extends boolean = false>(options?: Options<ClientCasesListUpdatesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientCasesListUpdatesResponses, ClientCasesListUpdatesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Cases',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Cases.ClientCasesController
     */
    public static clientCasesMarkNewAppointmentSeen<ThrowOnError extends boolean = false>(options: Options<ClientCasesMarkNewAppointmentSeenData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<ClientCasesMarkNewAppointmentSeenResponses, ClientCasesMarkNewAppointmentSeenErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Cases/newincoming/appointment/{callTicket}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Cases.ClientCasesController
     */
    public static clientCasesPrioritizedV2<ThrowOnError extends boolean = false>(options?: Options<ClientCasesPrioritizedV2Data, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientCasesPrioritizedV2Responses, ClientCasesPrioritizedV2Errors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Cases/v2/prioritized',
            ...options
        });
    }
}

export class ClientConditionsService {
    /**
     * Obsolete Drop in replacement by ClientReceptionConditionsController
     * Defined in VisibaCare.Api.Client.v2.Controllers.ClientConditionsController
     * @deprecated
     */
    public static clientConditionsList<ThrowOnError extends boolean = false>(options: Options<ClientConditionsListData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientConditionsListResponses, ClientConditionsListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Conditions',
            ...options
        });
    }
}

export class ClientDropInService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
     */
    public static clientDropInEnqueue<ThrowOnError extends boolean = false>(options: Options<ClientDropInEnqueueData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientDropInEnqueueResponses, ClientDropInEnqueueErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/DropIn/{dropInRoomId}/tickets',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
     */
    public static clientDropInCancel<ThrowOnError extends boolean = false>(options: Options<ClientDropInCancelData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<ClientDropInCancelResponses, ClientDropInCancelErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/DropIn/tickets/{ticket}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
     */
    public static clientDropInGetTicket<ThrowOnError extends boolean = false>(options: Options<ClientDropInGetTicketData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientDropInGetTicketResponses, ClientDropInGetTicketErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/DropIn/tickets/{ticket}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
     */
    public static getActiveTicket<ThrowOnError extends boolean = false>(options?: Options<GetActiveTicketData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetActiveTicketResponses, GetActiveTicketErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/DropIn/tickets/active',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
     */
    public static getActiveTicketForRoom<ThrowOnError extends boolean = false>(options: Options<GetActiveTicketForRoomData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetActiveTicketForRoomResponses, GetActiveTicketForRoomErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/DropIn/{dropInRoomId}/tickets/active',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
     */
    public static clientDropInUpload<ThrowOnError extends boolean = false>(options: Options<ClientDropInUploadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientDropInUploadResponses, ClientDropInUploadErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/DropIn/tickets/{ticket}/files',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientDropInController
     */
    public static clientDropInList<ThrowOnError extends boolean = false>(options: Options<ClientDropInListData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientDropInListResponses, ClientDropInListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/DropIn',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientDropInController
     */
    public static clientDropInGet<ThrowOnError extends boolean = false>(options: Options<ClientDropInGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientDropInGetResponses, ClientDropInGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/DropIn/{dropInRoomId}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientDropInController
     */
    public static clientDropInGetByUrlAlias<ThrowOnError extends boolean = false>(options: Options<ClientDropInGetByUrlAliasData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientDropInGetByUrlAliasResponses, ClientDropInGetByUrlAliasErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/DropIn/url/{urlAlias}',
            ...options
        });
    }
}

export class ClientFormsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
     */
    public static clientFormsList<ThrowOnError extends boolean = false>(options: Options<ClientFormsListData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientFormsListResponses, ClientFormsListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Forms',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
     */
    public static clientFormsGetFormGraph<ThrowOnError extends boolean = false>(options: Options<ClientFormsGetFormGraphData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientFormsGetFormGraphResponses, ClientFormsGetFormGraphErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Forms/{formId}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
     */
    public static clientFormsGetRespondant<ThrowOnError extends boolean = false>(options: Options<ClientFormsGetRespondantData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientFormsGetRespondantResponses, ClientFormsGetRespondantErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Forms/Respondants/{respondantId}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
     */
    public static clientFormsSaveAnswers<ThrowOnError extends boolean = false>(options: Options<ClientFormsSaveAnswersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientFormsSaveAnswersResponses, ClientFormsSaveAnswersErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Forms/Respondants/{respondantId}/Answers',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
     */
    public static clientFormsSetRespondantComplete<ThrowOnError extends boolean = false>(options: Options<ClientFormsSetRespondantCompleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientFormsSetRespondantCompleteResponses, ClientFormsSetRespondantCompleteErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Forms/Respondants/{respondantId}/completion',
            ...options
        });
    }
}

export class ClientGuiComponentsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientGuiComponentsController
     */
    public static clientGuiComponentsList<ThrowOnError extends boolean = false>(options: Options<ClientGuiComponentsListData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientGuiComponentsListResponses, ClientGuiComponentsListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/GuiComponents',
            ...options
        });
    }
}

export class ClientIdentityService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
     */
    public static clientIdentityDelete<ThrowOnError extends boolean = false>(options?: Options<ClientIdentityDeleteData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).delete<ClientIdentityDeleteResponses, ClientIdentityDeleteErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
     */
    public static clientIdentityGet<ThrowOnError extends boolean = false>(options?: Options<ClientIdentityGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientIdentityGetResponses, ClientIdentityGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
     */
    public static clientIdentityUpdate<ThrowOnError extends boolean = false>(options?: Options<ClientIdentityUpdateData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).put<ClientIdentityUpdateResponses, ClientIdentityUpdateErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
     */
    public static clientIdentityInviteablePersons<ThrowOnError extends boolean = false>(options?: Options<ClientIdentityInviteablePersonsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientIdentityInviteablePersonsResponses, ClientIdentityInviteablePersonsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity/InviteablePersons',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
     */
    public static clientIdentityCanDelete<ThrowOnError extends boolean = false>(options?: Options<ClientIdentityCanDeleteData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientIdentityCanDeleteResponses, ClientIdentityCanDeleteErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity/CanDelete',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
     */
    public static clientIdentitySignOut<ThrowOnError extends boolean = false>(options?: Options<ClientIdentitySignOutData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<ClientIdentitySignOutResponses, ClientIdentitySignOutErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity/SignOut',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
     */
    public static clientIdentityIsAlive<ThrowOnError extends boolean = false>(options?: Options<ClientIdentityIsAliveData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientIdentityIsAliveResponses, ClientIdentityIsAliveErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity/IsAlive',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
     */
    public static clientIdentityIsAliveOutsider<ThrowOnError extends boolean = false>(options?: Options<ClientIdentityIsAliveOutsiderData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientIdentityIsAliveOutsiderResponses, ClientIdentityIsAliveOutsiderErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity/IsAliveOutsider',
            ...options
        });
    }
}

export class ClientMessagingService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientMessagingController
     */
    public static clientMessagingList<ThrowOnError extends boolean = false>(options?: Options<ClientMessagingListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<ClientMessagingListResponses, ClientMessagingListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/MessagingConversations',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientMessagingController
     */
    public static clientMessagingGet<ThrowOnError extends boolean = false>(options: Options<ClientMessagingGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientMessagingGetResponses, ClientMessagingGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/MessagingConversations/{caseId}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientMessagingController
     */
    public static clientMessagingGetCase<ThrowOnError extends boolean = false>(options: Options<ClientMessagingGetCaseData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientMessagingGetCaseResponses, ClientMessagingGetCaseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/MessagingConversations/case/{caseId}',
            ...options
        });
    }
    
    /**
     * Used by clients to update the list of legal guardians invited to an existing messaging
     * conversation. The provided list represents the desired set of invited legal guardians;
     * guardians that are currently invited but are not in the list will be uninvited, and guardians
     * in the list that are not currently invited will be added as participants.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientMessagingController
     */
    public static clientMessagingUpdateLegalGuardians<ThrowOnError extends boolean = false>(options: Options<ClientMessagingUpdateLegalGuardiansData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<ClientMessagingUpdateLegalGuardiansResponses, ClientMessagingUpdateLegalGuardiansErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/MessagingConversations/{caseId}/LegalGuardians',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
}

export class ClientMessagingCompletionService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientMessagingCompletionController
     */
    public static clientMessagingCompletionCompleteCase<ThrowOnError extends boolean = false>(options: Options<ClientMessagingCompletionCompleteCaseData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<ClientMessagingCompletionCompleteCaseResponses, ClientMessagingCompletionCompleteCaseErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/MessagingConversations/{caseId}/completed',
            ...options
        });
    }
}

export class ClientNotificationTargetsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientNotificationTargetsController
     */
    public static clientNotificationTargetsDeleteStandardTarget<ThrowOnError extends boolean = false>(options?: Options<ClientNotificationTargetsDeleteStandardTargetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).delete<ClientNotificationTargetsDeleteStandardTargetResponses, ClientNotificationTargetsDeleteStandardTargetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/NotificationTargets/standardTarget',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientNotificationTargetsController
     */
    public static clientNotificationTargetsSetStandardTarget<ThrowOnError extends boolean = false>(options?: Options<ClientNotificationTargetsSetStandardTargetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).put<ClientNotificationTargetsSetStandardTargetResponses, ClientNotificationTargetsSetStandardTargetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/NotificationTargets/standardTarget',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientNotificationTargetsController
     */
    public static clientNotificationTargetsDeleteVoipTarget<ThrowOnError extends boolean = false>(options?: Options<ClientNotificationTargetsDeleteVoipTargetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).delete<ClientNotificationTargetsDeleteVoipTargetResponses, ClientNotificationTargetsDeleteVoipTargetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/NotificationTargets/voipTarget',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientNotificationTargetsController
     */
    public static clientNotificationTargetsSetVoipTarget<ThrowOnError extends boolean = false>(options?: Options<ClientNotificationTargetsSetVoipTargetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).put<ClientNotificationTargetsSetVoipTargetResponses, ClientNotificationTargetsSetVoipTargetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/NotificationTargets/voipTarget',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
}

export class ClientPaymentsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientPaymentsController
     */
    public static clientPaymentsPaymentServices<ThrowOnError extends boolean = false>(options: Options<ClientPaymentsPaymentServicesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientPaymentsPaymentServicesResponses, ClientPaymentsPaymentServicesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Payments/{paymentBillId}/Services',
            ...options
        });
    }
}

export class ClientReceptionConditionsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.ClientReceptionConditionsController
     */
    public static clientReceptionConditionsList<ThrowOnError extends boolean = false>(options: Options<ClientReceptionConditionsListData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientReceptionConditionsListResponses, ClientReceptionConditionsListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/Conditions',
            ...options
        });
    }
}

export class ClientRegistrationService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientRegistrationController
     */
    public static clientRegistrationGetRegistration<ThrowOnError extends boolean = false>(options: Options<ClientRegistrationGetRegistrationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientRegistrationGetRegistrationResponses, ClientRegistrationGetRegistrationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Registration/Registration/{registrationTicket}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientRegistrationController
     */
    public static clientRegistrationCompleteRegistration<ThrowOnError extends boolean = false>(options: Options<ClientRegistrationCompleteRegistrationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientRegistrationCompleteRegistrationResponses, ClientRegistrationCompleteRegistrationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Registration/Registration/{registrationTicket}',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
}

export class ClientSmsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
     */
    public static clientSmsStartAuth<ThrowOnError extends boolean = false>(options: Options<ClientSmsStartAuthData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientSmsStartAuthResponses, ClientSmsStartAuthErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/SendCode',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
     */
    public static clientSmsStartAuthWithCallTicket<ThrowOnError extends boolean = false>(options: Options<ClientSmsStartAuthWithCallTicketData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientSmsStartAuthWithCallTicketResponses, ClientSmsStartAuthWithCallTicketErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/SendCodeWithCallTicket',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
     */
    public static clientSmsReSendCode<ThrowOnError extends boolean = false>(options: Options<ClientSmsReSendCodeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientSmsReSendCodeResponses, ClientSmsReSendCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/ReSendCode',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
     */
    public static clientSmsConfirmCode<ThrowOnError extends boolean = false>(options: Options<ClientSmsConfirmCodeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientSmsConfirmCodeResponses, ClientSmsConfirmCodeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/ConfirmCode',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
     */
    public static clientSmsPreRegisteredNumber<ThrowOnError extends boolean = false>(options: Options<ClientSmsPreRegisteredNumberData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientSmsPreRegisteredNumberResponses, ClientSmsPreRegisteredNumberErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/PreRegisteredNumber',
            ...options
        });
    }
}

export class ClientSurveysService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientSurveysController
     */
    public static clientSurveysGetSurvey<ThrowOnError extends boolean = false>(options: Options<ClientSurveysGetSurveyData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientSurveysGetSurveyResponses, ClientSurveysGetSurveyErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Surveys/{alias}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientSurveysController
     */
    public static clientSurveysAnswerSurvey<ThrowOnError extends boolean = false>(options: Options<ClientSurveysAnswerSurveyData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientSurveysAnswerSurveyResponses, ClientSurveysAnswerSurveyErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Surveys/{alias}',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
}

export class ClientThemeService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientThemeController
     */
    public static clientThemeGetPublicTheme<ThrowOnError extends boolean = false>(options: Options<ClientThemeGetPublicThemeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientThemeGetPublicThemeResponses, ClientThemeGetPublicThemeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/Theme/Public',
            ...options
        });
    }
}

export class ClientTimeslotsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsTimeslots<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsTimeslotsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientTimeslotsTimeslotsResponses, ClientTimeslotsTimeslotsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsTimeslot<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsTimeslotData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientTimeslotsTimeslotResponses, ClientTimeslotsTimeslotErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots/{id}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsSearchLocalityAvailability<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsSearchLocalityAvailabilityData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientTimeslotsSearchLocalityAvailabilityResponses, ClientTimeslotsSearchLocalityAvailabilityErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots/Availability',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsGetAvailabilityCounts<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsGetAvailabilityCountsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientTimeslotsGetAvailabilityCountsResponses, ClientTimeslotsGetAvailabilityCountsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots/AvailabilityCounts',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsGetSearchCapabilities<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsGetSearchCapabilitiesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientTimeslotsGetSearchCapabilitiesResponses, ClientTimeslotsGetSearchCapabilitiesErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots/searchcapabilities',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsBookSlot<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsBookSlotData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientTimeslotsBookSlotResponses, ClientTimeslotsBookSlotErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots/{id}/book',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsGetRescheduleTimeslots<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsGetRescheduleTimeslotsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientTimeslotsGetRescheduleTimeslotsResponses, ClientTimeslotsGetRescheduleTimeslotsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots/Reschedule/{ticket}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsRebookWithNewTimeslot<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsRebookWithNewTimeslotData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientTimeslotsRebookWithNewTimeslotResponses, ClientTimeslotsRebookWithNewTimeslotErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots/Reschedule/{ticket}',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
     */
    public static clientTimeslotsGetRescheduleAvailabilityCounts<ThrowOnError extends boolean = false>(options: Options<ClientTimeslotsGetRescheduleAvailabilityCountsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientTimeslotsGetRescheduleAvailabilityCountsResponses, ClientTimeslotsGetRescheduleAvailabilityCountsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/Timeslots/RescheduleAvailabilityCounts/{ticket}',
            ...options
        });
    }
}

export class ClientUnitsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
     */
    public static clientUnitsListUnits<ThrowOnError extends boolean = false>(options: Options<ClientUnitsListUnitsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientUnitsListUnitsResponses, ClientUnitsListUnitsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/tree',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
     */
    public static clientUnitsGet<ThrowOnError extends boolean = false>(options: Options<ClientUnitsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientUnitsGetResponses, ClientUnitsGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/config/{platform}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
     */
    public static clientUnitsGetTheme<ThrowOnError extends boolean = false>(options: Options<ClientUnitsGetThemeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientUnitsGetThemeResponses, ClientUnitsGetThemeErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/theme/{platform}',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
     */
    public static clientUnitsGetAbout<ThrowOnError extends boolean = false>(options: Options<ClientUnitsGetAboutData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientUnitsGetAboutResponses, ClientUnitsGetAboutErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/about',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
     */
    public static clientUnitsGetTexts<ThrowOnError extends boolean = false>(options: Options<ClientUnitsGetTextsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientUnitsGetTextsResponses, ClientUnitsGetTextsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/texts',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
     */
    public static clientUnitsGetIdentifierConflicts<ThrowOnError extends boolean = false>(options: Options<ClientUnitsGetIdentifierConflictsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientUnitsGetIdentifierConflictsResponses, ClientUnitsGetIdentifierConflictsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/IdentifierConflicts',
            ...options
        });
    }
}

export class ClientUsageAgreementsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientUsageAgreementsController
     */
    public static clientUsageAgreementsGetDocuments<ThrowOnError extends boolean = false>(options: Options<ClientUsageAgreementsGetDocumentsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ClientUsageAgreementsGetDocumentsResponses, ClientUsageAgreementsGetDocumentsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/UsageAgreements',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientUsageAgreementsController
     */
    public static clientUsageAgreementsAgreeToDocument<ThrowOnError extends boolean = false>(options: Options<ClientUsageAgreementsAgreeToDocumentData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<ClientUsageAgreementsAgreeToDocumentResponses, ClientUsageAgreementsAgreeToDocumentErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/UsageAgreements',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
}

export class CurrencyService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.CurrencyController
     */
    public static currencyGet<ThrowOnError extends boolean = false>(options: Options<CurrencyGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<CurrencyGetResponses, CurrencyGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/Currency',
            ...options
        });
    }
}

export class DemandManagementService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.DemandManagementController
     */
    public static demandManagementIsMessagingOpen<ThrowOnError extends boolean = false>(options: Options<DemandManagementIsMessagingOpenData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<DemandManagementIsMessagingOpenResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/demand-management/messaging',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.DemandManagementController
     */
    public static demandManagementIsTriageOpen<ThrowOnError extends boolean = false>(options: Options<DemandManagementIsTriageOpenData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<DemandManagementIsTriageOpenResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/demand-management/triage-entry',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.DemandManagementController
     */
    public static demandManagementGetRuleSet<ThrowOnError extends boolean = false>(options: Options<DemandManagementGetRuleSetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<DemandManagementGetRuleSetResponses, DemandManagementGetRuleSetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/demand-management/rule-set',
            ...options
        });
    }
}

export class ExternalDataService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ExternalDataController
     */
    public static externalDataUploadExternalData<ThrowOnError extends boolean = false>(options?: Options<ExternalDataUploadExternalDataData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<ExternalDataUploadExternalDataResponses, ExternalDataUploadExternalDataErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/ExternalData',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
}

export class HomeGuiComponentsService {
    /**
     * This endpoint is for older mobile apps. Can't introduce a new type here or they will not work.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.HomeGuiComponentsController
     */
    public static homeGuiComponentsListDeprecated<ThrowOnError extends boolean = false>(options: Options<HomeGuiComponentsListDeprecatedData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<HomeGuiComponentsListDeprecatedResponses, HomeGuiComponentsListDeprecatedErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/HomeGuiComponents',
            ...options
        });
    }
    
    /**
     * This keeps the new behaviour with ListedAtReception model. It should be called from patient old and removed when that is removed.
     * Obsolete This endpoint is for patient old. Remove whenever patient old is ditched.
     * Defined in VisibaCare.Api.Client.v2.Controllers.HomeGuiComponentsController
     * @deprecated
     */
    public static homeGuiComponentsList<ThrowOnError extends boolean = false>(options: Options<HomeGuiComponentsListData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<HomeGuiComponentsListResponses, HomeGuiComponentsListErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/HomeGuiComponents/v2',
            ...options
        });
    }
}

export class IdentityIdpService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.IdentityIdpController
     */
    public static identityIdpSignOutIdp<ThrowOnError extends boolean = false>(options?: Options<IdentityIdpSignOutIdpData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<IdentityIdpSignOutIdpResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity/SignOutIdp',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.IdentityIdpController
     */
    public static identityIdpSignOutIdp2<ThrowOnError extends boolean = false>(options?: Options<IdentityIdpSignOutIdp2Data, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<IdentityIdpSignOutIdp2Responses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Identity/SignOutIdp',
            ...options
        });
    }
}

export class IdpAuthMethodsService {
    /**
     * List authentication methods that belongs to a licence holder.
     *  Defined in VisibaCare.Api.Client.Controllers.Auth.IdpAuthMethodsController
     */
    public static idpAuthMethodsGetAuthMethods<ThrowOnError extends boolean = false>(options: Options<IdpAuthMethodsGetAuthMethodsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<IdpAuthMethodsGetAuthMethodsResponses, IdpAuthMethodsGetAuthMethodsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/client/auth/idp/{licenceHolderId}/methods',
            ...options
        });
    }
}

export class InformationGatheringService {
    /**
     * Checks whether the NHS-authenticated client can use the information-gathering journey.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.InformationGatheringController
     */
    public static informationGatheringGetEligibility<ThrowOnError extends boolean = false>(options?: Options<InformationGatheringGetEligibilityData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<InformationGatheringGetEligibilityResponses, InformationGatheringGetEligibilityErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/InformationGathering/Eligibility',
            ...options
        });
    }
    
    /**
     * Stores a completed information-gathering submission before destination navigation starts.
     * Each request creates a new submission and returns its ID.
     */
    public static informationGatheringStoreSubmission<ThrowOnError extends boolean = false>(options?: Options<InformationGatheringStoreSubmissionData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<InformationGatheringStoreSubmissionResponses, InformationGatheringStoreSubmissionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/InformationGathering/Submissions',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
}

export class LocaleService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.LocaleController
     */
    public static localeGet<ThrowOnError extends boolean = false>(options: Options<LocaleGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<LocaleGetResponses, LocaleGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/Locale',
            ...options
        });
    }
}

export class NavigationService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.NavigationController
     */
    public static navigationStart<ThrowOnError extends boolean = false>(options: Options<NavigationStartData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<NavigationStartResponses, NavigationStartErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/navigation/start',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
}

export class NotificationSettingsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.NotificationSettingsController
     */
    public static notificationSettingsGetComplianceSettings<ThrowOnError extends boolean = false>(options?: Options<NotificationSettingsGetComplianceSettingsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<NotificationSettingsGetComplianceSettingsResponses, NotificationSettingsGetComplianceSettingsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/NotificationSettings/Compliance',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.NotificationSettingsController
     */
    public static notificationSettingsUpdateComplianceSettings<ThrowOnError extends boolean = false>(options?: Options<NotificationSettingsUpdateComplianceSettingsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).put<NotificationSettingsUpdateComplianceSettingsResponses, NotificationSettingsUpdateComplianceSettingsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/NotificationSettings/Compliance',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
}

export class PaymentsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.PaymentsController
     */
    public static paymentsGetBill<ThrowOnError extends boolean = false>(options: Options<PaymentsGetBillData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<PaymentsGetBillResponses, PaymentsGetBillErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Payments/{paymentBillId}',
            ...options
        });
    }
}

export class PhysicalLocationsService {
    /**
     * Retrieves all physical locations accessible to the specified unit (inferred from the route).
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.PhysicalLocationsController
     */
    public static physicalLocationsGetPhysicalLocation<ThrowOnError extends boolean = false>(options: Options<PhysicalLocationsGetPhysicalLocationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<PhysicalLocationsGetPhysicalLocationResponses, PhysicalLocationsGetPhysicalLocationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/PhysicalLocations/{physicalLocationId}',
            ...options
        });
    }
    
    /**
     * Retrieves all physical locations accessible to the specified unit (inferred from the route).
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.PhysicalLocationsController
     */
    public static physicalLocationsGetPhysicalLocations<ThrowOnError extends boolean = false>(options: Options<PhysicalLocationsGetPhysicalLocationsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<PhysicalLocationsGetPhysicalLocationsResponses, PhysicalLocationsGetPhysicalLocationsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/PhysicalLocations',
            ...options
        });
    }
}

export class RateService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.RateController
     */
    public static rateGetMessagingPrice<ThrowOnError extends boolean = false>(options: Options<RateGetMessagingPriceData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<RateGetMessagingPriceResponses, RateGetMessagingPriceErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Rate/{receptionId}/GetMessagingConversationPrice',
            ...options
        });
    }
}

export class RecentReceptionsService {
    /**
     * Retrieve a list of the most recent receptions you have visited, in order of most recent visit first.
     * Only your latest visit on each reception will be present in the list.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.RecentReceptionsController
     */
    public static recentReceptionsListRecentlyVisited<ThrowOnError extends boolean = false>(options?: Options<RecentReceptionsListRecentlyVisitedData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<RecentReceptionsListRecentlyVisitedResponses, RecentReceptionsListRecentlyVisitedErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Receptions/RecentlyVisited',
            ...options
        });
    }
    
    /**
     * Register a new reception visit at the current time.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.RecentReceptionsController
     */
    public static recentReceptionsRegisterVisit<ThrowOnError extends boolean = false>(options?: Options<RecentReceptionsRegisterVisitData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<RecentReceptionsRegisterVisitResponses, RecentReceptionsRegisterVisitErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Receptions/RecentlyVisited',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Deletes the reception visit for currently logged in client.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.RecentReceptionsController
     */
    public static recentReceptionsDeleteVisit<ThrowOnError extends boolean = false>(options: Options<RecentReceptionsDeleteVisitData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<RecentReceptionsDeleteVisitResponses, RecentReceptionsDeleteVisitErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/Receptions/RecentlyVisited/{receptionId}',
            ...options
        });
    }
}

export class ReceptionService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ReceptionController
     */
    public static receptionListFromUnitId<ThrowOnError extends boolean = false>(options: Options<ReceptionListFromUnitIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ReceptionListFromUnitIdResponses, ReceptionListFromUnitIdErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/Receptions',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.ReceptionController
     */
    public static receptionSearch<ThrowOnError extends boolean = false>(options: Options<ReceptionSearchData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ReceptionSearchResponses, ReceptionSearchErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/Receptions/Search',
            ...options
        });
    }
}

export class RedRobinService {
    /**
     * Obsolete Use StartSessionV2 instead.
     * Defined in VisibaCare.Api.Client.v2.Controllers.RedRobinController
     * @deprecated
     */
    public static redRobinStartSession<ThrowOnError extends boolean = false>(options: Options<RedRobinStartSessionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<RedRobinStartSessionResponses, RedRobinStartSessionErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/RedRobin/StartSession',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.RedRobinController
     */
    public static redRobinStartSessionV2<ThrowOnError extends boolean = false>(options: Options<RedRobinStartSessionV2Data, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<RedRobinStartSessionV2Responses, RedRobinStartSessionV2Errors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/RedRobin/StartSessionV2',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.RedRobinController
     */
    public static redRobinGetPatientEntryUrl<ThrowOnError extends boolean = false>(options: Options<RedRobinGetPatientEntryUrlData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<RedRobinGetPatientEntryUrlResponses, RedRobinGetPatientEntryUrlErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/RedRobin/session/{sessionId}/entryUrl',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.RedRobinController
     */
    public static redRobinGetAccessInfo<ThrowOnError extends boolean = false>(options: Options<RedRobinGetAccessInfoData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<RedRobinGetAccessInfoResponses, RedRobinGetAccessInfoErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/RedRobin/accessInfo',
            ...options
        });
    }
}

export class SearchLimitationService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.SearchLimitationController
     */
    public static searchLimitationDeleteContext<ThrowOnError extends boolean = false>(options: Options<SearchLimitationDeleteContextData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<SearchLimitationDeleteContextResponses, SearchLimitationDeleteContextErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/SearchLimitation',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.SearchLimitationController
     */
    public static searchLimitationGetSearchLimitation<ThrowOnError extends boolean = false>(options: Options<SearchLimitationGetSearchLimitationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<SearchLimitationGetSearchLimitationResponses, SearchLimitationGetSearchLimitationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/SearchLimitation',
            ...options
        });
    }
    
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.SearchLimitationController
     */
    public static searchLimitationCreateSearchLimitation<ThrowOnError extends boolean = false>(options: Options<SearchLimitationCreateSearchLimitationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<SearchLimitationCreateSearchLimitationResponses, unknown, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/receptions/{receptionId}/SearchLimitation',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
}

export class SessionInformationService {
    /**
     * Get information about the max session length for this client.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.SessionInformationController
     */
    public static sessionInformationGetClientSessionInformation<ThrowOnError extends boolean = false>(options?: Options<SessionInformationGetClientSessionInformationData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<SessionInformationGetClientSessionInformationResponses, SessionInformationGetClientSessionInformationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/session/client',
            ...options
        });
    }
    
    /**
     * Get information about the max session length to this guest.
     *  Defined in VisibaCare.Api.Client.v2.Controllers.SessionInformationController
     */
    public static sessionInformationGetGuestSessionInformation<ThrowOnError extends boolean = false>(options?: Options<SessionInformationGetGuestSessionInformationData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<SessionInformationGetGuestSessionInformationResponses, SessionInformationGetGuestSessionInformationErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/session/guest',
            ...options
        });
    }
}

export class TranslationSetsService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.TranslationSetsController
     */
    public static translationSetsGet<ThrowOnError extends boolean = false>(options: Options<TranslationSetsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<TranslationSetsGetResponses, TranslationSetsGetErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/{licenceHolderId}/TranslationSets/{translationSet}/{languageCode}',
            ...options
        });
    }
}

export class UnitsPhysicalLocationsService {
    /**
     * Retrieves all physical locations accessible to the specified unit (inferred from the route).
     *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.UnitsPhysicalLocationsController
     */
    public static unitsPhysicalLocationsGetPhysicalLocations<ThrowOnError extends boolean = false>(options: Options<UnitsPhysicalLocationsGetPhysicalLocationsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<UnitsPhysicalLocationsGetPhysicalLocationsResponses, UnitsPhysicalLocationsGetPhysicalLocationsErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/units/{unitId}/PhysicalLocations',
            ...options
        });
    }
}

export class UserFilesService {
    /**
     *  Defined in VisibaCare.Api.Client.v2.Controllers.UserFilesController
     */
    public static userFilesGetFileIdentifier<ThrowOnError extends boolean = false>(options?: Options<UserFilesGetFileIdentifierData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<UserFilesGetFileIdentifierResponses, UserFilesGetFileIdentifierErrors, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/api/Client/v2/UserFiles',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options?.headers
            }
        });
    }
}